import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_b541b37c from 'nuxt_plugin_bootstrapvue_b541b37c' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_0d0c24bb from 'nuxt_plugin_cookieuniversalnuxt_0d0c24bb' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuewaitplugin_7fedbcf6 from 'nuxt_plugin_vuewaitplugin_7fedbcf6' // Source: ./vue-wait-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_c3f6e8f0 from 'nuxt_plugin_pluginutils_c3f6e8f0' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_35df525a from 'nuxt_plugin_pluginrouting_35df525a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_66c53d7c from 'nuxt_plugin_pluginmain_66c53d7c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_portalvue_e91e55c0 from 'nuxt_plugin_portalvue_e91e55c0' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_sentryserver_703807d7 from 'nuxt_plugin_sentryserver_703807d7' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_0a7e964f from 'nuxt_plugin_sentryclient_0a7e964f' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_config_56a52038 from 'nuxt_plugin_config_56a52038' // Source: ../plugins/config/config (mode: 'all')
import nuxt_plugin_utils_0fe8b99c from 'nuxt_plugin_utils_0fe8b99c' // Source: ../plugins/utils/utils (mode: 'all')
import nuxt_plugin_oneAPI_5fc577f8 from 'nuxt_plugin_oneAPI_5fc577f8' // Source: ../plugins/oneAPI/oneAPI (mode: 'all')
import nuxt_plugin_orderpath_4f4fe7ce from 'nuxt_plugin_orderpath_4f4fe7ce' // Source: ../plugins/services/orderpath (mode: 'all')
import nuxt_plugin_oneCore_e0695124 from 'nuxt_plugin_oneCore_e0695124' // Source: ../plugins/oneCore (mode: 'all')
import nuxt_plugin_FieldValidationMixin_4a79f4b6 from 'nuxt_plugin_FieldValidationMixin_4a79f4b6' // Source: ../plugins/FieldValidationMixin (mode: 'all')
import nuxt_plugin_sentry_3c9afb14 from 'nuxt_plugin_sentry_3c9afb14' // Source: ../plugins/sentry (mode: 'all')
import nuxt_plugin_customlogger_a52cebca from 'nuxt_plugin_customlogger_a52cebca' // Source: ../plugins/custom-logger/custom-logger.ts (mode: 'all')
import nuxt_plugin_sdk_6e031dfa from 'nuxt_plugin_sdk_6e031dfa' // Source: ../plugins/sdk (mode: 'client')
import nuxt_plugin_oneplugins_7e0224eb from 'nuxt_plugin_oneplugins_7e0224eb' // Source: ../plugins/one-plugins.ts (mode: 'client')
import nuxt_plugin_vuemq_30a53c3c from 'nuxt_plugin_vuemq_30a53c3c' // Source: ../plugins/vue-mq (mode: 'client')
import nuxt_plugin_backdrop_7244492d from 'nuxt_plugin_backdrop_7244492d' // Source: ../plugins/backdrop (mode: 'client')
import nuxt_plugin_oneUI_fa1b43fa from 'nuxt_plugin_oneUI_fa1b43fa' // Source: ../plugins/oneUI (mode: 'all')
import nuxt_plugin_router_eb3ec0fc from 'nuxt_plugin_router_eb3ec0fc' // Source: ../plugins/route-utils/router (mode: 'all')
import nuxt_plugin_locale_3e9b109c from 'nuxt_plugin_locale_3e9b109c' // Source: ../plugins/locale.ts (mode: 'all')
import nuxt_plugin_OneTestIdDirective_0daa77da from 'nuxt_plugin_OneTestIdDirective_0daa77da' // Source: ../plugins/OneTestIdDirective.ts (mode: 'all')
import nuxt_plugin_scroll_3ccfdd38 from 'nuxt_plugin_scroll_3ccfdd38' // Source: ../plugins/scroll (mode: 'client')
import nuxt_plugin_idle_56cb242b from 'nuxt_plugin_idle_56cb242b' // Source: ../plugins/idle (mode: 'client')
import nuxt_plugin_notification_27322642 from 'nuxt_plugin_notification_27322642' // Source: ../plugins/notification (mode: 'client')
import nuxt_plugin_intersectionobserver_a4682bba from 'nuxt_plugin_intersectionobserver_a4682bba' // Source: ../plugins/intersection-observer (mode: 'client')
import nuxt_plugin_storageSync_6101adb4 from 'nuxt_plugin_storageSync_6101adb4' // Source: ../plugins/storageSync/storageSync (mode: 'client')
import nuxt_plugin_gtm_1983d00c from 'nuxt_plugin_gtm_1983d00c' // Source: ../plugins/gtm/gtm (mode: 'client')
import nuxt_plugin_vclickoutside_9abbdedc from 'nuxt_plugin_vclickoutside_9abbdedc' // Source: ../plugins/v-click-outside (mode: 'client')
import nuxt_plugin_global_64c9a38c from 'nuxt_plugin_global_64c9a38c' // Source: ../plugins/global (mode: 'all')
import nuxt_plugin_PwaManager_1898f4bf from 'nuxt_plugin_PwaManager_1898f4bf' // Source: ../plugins/pwa/PwaManager (mode: 'all')
import nuxt_plugin_vueyoutube_4785ce32 from 'nuxt_plugin_vueyoutube_4785ce32' // Source: ../plugins/vue-youtube.js (mode: 'all')
import nuxt_plugin_vuemask_613243e6 from 'nuxt_plugin_vuemask_613243e6' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_polyfills_d73145e6 from 'nuxt_plugin_polyfills_d73145e6' // Source: ../plugins/polyfills (mode: 'client')
import nuxt_plugin_vuegalleryclient_202c62b2 from 'nuxt_plugin_vuegalleryclient_202c62b2' // Source: ../plugins/vue-gallery.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_b541b37c === 'function') {
    await nuxt_plugin_bootstrapvue_b541b37c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_0d0c24bb === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_0d0c24bb(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewaitplugin_7fedbcf6 === 'function') {
    await nuxt_plugin_vuewaitplugin_7fedbcf6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c3f6e8f0 === 'function') {
    await nuxt_plugin_pluginutils_c3f6e8f0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_35df525a === 'function') {
    await nuxt_plugin_pluginrouting_35df525a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_66c53d7c === 'function') {
    await nuxt_plugin_pluginmain_66c53d7c(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_e91e55c0 === 'function') {
    await nuxt_plugin_portalvue_e91e55c0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_703807d7 === 'function') {
    await nuxt_plugin_sentryserver_703807d7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_0a7e964f === 'function') {
    await nuxt_plugin_sentryclient_0a7e964f(app.context, inject)
  }

  if (typeof nuxt_plugin_config_56a52038 === 'function') {
    await nuxt_plugin_config_56a52038(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_0fe8b99c === 'function') {
    await nuxt_plugin_utils_0fe8b99c(app.context, inject)
  }

  if (typeof nuxt_plugin_oneAPI_5fc577f8 === 'function') {
    await nuxt_plugin_oneAPI_5fc577f8(app.context, inject)
  }

  if (typeof nuxt_plugin_orderpath_4f4fe7ce === 'function') {
    await nuxt_plugin_orderpath_4f4fe7ce(app.context, inject)
  }

  if (typeof nuxt_plugin_oneCore_e0695124 === 'function') {
    await nuxt_plugin_oneCore_e0695124(app.context, inject)
  }

  if (typeof nuxt_plugin_FieldValidationMixin_4a79f4b6 === 'function') {
    await nuxt_plugin_FieldValidationMixin_4a79f4b6(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_3c9afb14 === 'function') {
    await nuxt_plugin_sentry_3c9afb14(app.context, inject)
  }

  if (typeof nuxt_plugin_customlogger_a52cebca === 'function') {
    await nuxt_plugin_customlogger_a52cebca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sdk_6e031dfa === 'function') {
    await nuxt_plugin_sdk_6e031dfa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_oneplugins_7e0224eb === 'function') {
    await nuxt_plugin_oneplugins_7e0224eb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemq_30a53c3c === 'function') {
    await nuxt_plugin_vuemq_30a53c3c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_backdrop_7244492d === 'function') {
    await nuxt_plugin_backdrop_7244492d(app.context, inject)
  }

  if (typeof nuxt_plugin_oneUI_fa1b43fa === 'function') {
    await nuxt_plugin_oneUI_fa1b43fa(app.context, inject)
  }

  if (typeof nuxt_plugin_router_eb3ec0fc === 'function') {
    await nuxt_plugin_router_eb3ec0fc(app.context, inject)
  }

  if (typeof nuxt_plugin_locale_3e9b109c === 'function') {
    await nuxt_plugin_locale_3e9b109c(app.context, inject)
  }

  if (typeof nuxt_plugin_OneTestIdDirective_0daa77da === 'function') {
    await nuxt_plugin_OneTestIdDirective_0daa77da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scroll_3ccfdd38 === 'function') {
    await nuxt_plugin_scroll_3ccfdd38(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_idle_56cb242b === 'function') {
    await nuxt_plugin_idle_56cb242b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notification_27322642 === 'function') {
    await nuxt_plugin_notification_27322642(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intersectionobserver_a4682bba === 'function') {
    await nuxt_plugin_intersectionobserver_a4682bba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_storageSync_6101adb4 === 'function') {
    await nuxt_plugin_storageSync_6101adb4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_1983d00c === 'function') {
    await nuxt_plugin_gtm_1983d00c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vclickoutside_9abbdedc === 'function') {
    await nuxt_plugin_vclickoutside_9abbdedc(app.context, inject)
  }

  if (typeof nuxt_plugin_global_64c9a38c === 'function') {
    await nuxt_plugin_global_64c9a38c(app.context, inject)
  }

  if (typeof nuxt_plugin_PwaManager_1898f4bf === 'function') {
    await nuxt_plugin_PwaManager_1898f4bf(app.context, inject)
  }

  if (typeof nuxt_plugin_vueyoutube_4785ce32 === 'function') {
    await nuxt_plugin_vueyoutube_4785ce32(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_613243e6 === 'function') {
    await nuxt_plugin_vuemask_613243e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_d73145e6 === 'function') {
    await nuxt_plugin_polyfills_d73145e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegalleryclient_202c62b2 === 'function') {
    await nuxt_plugin_vuegalleryclient_202c62b2(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
